/**
 * Склонение числительных
 *
 * @param {string[]} titles заголовки
 * @param {number} num Исходное число
 *
 * @return {string}
 *
 * @example declOfNum(['просмотр', 'просмотра', 'просмотров'], 1) => 'просмотр';
 * @example declOfNum(['просмотр', 'просмотра', 'просмотров'], 2) => 'просмотра';
 */
export const declOfNum = (titles: string[], num: number) => {
	const cases = [2, 0, 1, 1, 1, 2];

	return titles[(num % 100 > 4 && num % 100 < 20) ? 2 : cases[(num % 10 < 5) ? num % 10 : 5]];
};
